module.exports = __webpack_public_path__ + "static/media/259-european-union.7f678dca.svg";